export default "__VITE_ASSET__BpvPJ1kK__"